import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import {
	defaultCompanyLogoURL,
	defaultCompanyCoverPhoto,
} from "../../../utils/constants";
import { Region } from "../../common/layout/region";
import CoverPhoto from "./coverPhoto";
import Operation from "./operationalInformation";
import BasicInformation from "./basicInformation";
import ProfileCompletedModal from "./profileCompletedModal";
import Preview from "./preview";
import VoiceOfSeniors from "./voiceOfSeniors";
import { ReturnBackIcon, EyeIcon } from "../../common/icons";
import { connect } from "react-redux";
import GalkButton from "../../common/component/button";
import { Progress, Menu } from "antd";
import "./style.css";

var voiceOfSeniorsBool = 0;
var basicInfoBool = 0;
var coverPhotoBool = 0;
var corporateLogoBool = 0;
var operationalInfoBool = 0;
var isProfileCompleted = false;
const percentagePerStep = 20;

export const setCompletionBool = (boolName, boolValue = 1) => {
	if (boolName == "voiceOfSeniors") voiceOfSeniorsBool = boolValue;
	if (boolName == "basicInfo") basicInfoBool = boolValue;
	if (boolName == "coverPhoto") coverPhotoBool = boolValue;
	if (boolName == "corporateLogo") corporateLogoBool = boolValue;
	if (boolName == "operationalInfo") operationalInfoBool = boolValue;

	if (
		((((voiceOfSeniorsBool == basicInfoBool) == operationalInfoBool) ==
			corporateLogoBool) ==
			coverPhotoBool) ==
		1
	) {
		isProfileCompleted = true;
	} else {
		isProfileCompleted = false;
	}
};
const CompanyProfile = ({ company, match, history }) => {
	const { t } = useTranslation();
	const [showModal, setShowModal] = useState(true);
	const [showStudentView, setShowStudentView] = useState(false);
	const [isProfileCompleted, setIsProfileCompleted] = useState(false);

	const closeModal = () => {
		setShowModal(false);
		setIsProfileCompleted(false);
	};

	const setCompletionBool = (boolName, boolValue = 1) => {
		if (boolName === "basicInfo") basicInfoBool = boolValue;
		if (boolName === "coverPhoto") coverPhotoBool = boolValue;
		if (boolName === "corporateLogo") corporateLogoBool = boolValue;
		if (boolName === "operationalInfo") operationalInfoBool = boolValue;
		if (boolName === "voiceOfSeniors") voiceOfSeniorsBool = boolValue;

		if (boolName === "basicInfo" && boolValue === 1) {
			setIsProfileCompleted(true);
		} else {
			setIsProfileCompleted(false);
		}
	};

	if (Object.keys(company).length) {
		if (company.voiceOfSeniors != "") voiceOfSeniorsBool = 1;
		if (company.website != "") basicInfoBool = 1;
		if (company.description != "") operationalInfoBool = 1;
		if (company.logo != defaultCompanyLogoURL) corporateLogoBool = 1;
		if (company.coverPhoto != defaultCompanyCoverPhoto) coverPhotoBool = 1;
	}

	const onMenuChange = ({ key }) => {
		if (key === "2") history.push("/AccountSetting/TeamMembers");
	};

	return (
		<Region>
			<div className="accountSetting_pageTitle">
				{company ? company.nameInEnglish : `${t("company_profile")}`}
			</div>
			<Menu
				mode="horizontal"
				defaultSelectedKeys={["1"]}
				onClick={onMenuChange}
			>
				<Menu.Item key="1">
					{t("accountSetting_companyInfo_tabHeader")}
				</Menu.Item>
				<Menu.Item key="2">
					{t("accountSetting_memberInfo_tabHeader")}
				</Menu.Item>
			</Menu>
			<div className="accountSetting_companyProfile_bodyContainer">
				<div style={{ display: "flex", justifyContent: "flex-end" }}>
					{showStudentView ? (
						<GalkButton
							type="default"
							onClick={() => setShowStudentView(false)}
							height={36}
							additionalStyle={{ padding: "13px 16px" }}
						>
							<ReturnBackIcon width={14} height={14} />
							{t("accountSetting_action_studentPreviewBack")}
						</GalkButton>
					) : (
						<GalkButton
							type="primary"
							onClick={() => setShowStudentView(true)}
							height={36}
							additionalStyle={{ padding: "13px 16px" }}
						>
							<EyeIcon width={14} height={14} />
							{t("accountSetting_action_studentPreview")}
						</GalkButton>
					)}
				</div>
				<div id="ProgressBar" style={{ margin: "10px 0" }}>
					<Progress
						percent={
							percentagePerStep * voiceOfSeniorsBool +
							percentagePerStep * basicInfoBool +
							percentagePerStep * coverPhotoBool +
							percentagePerStep * corporateLogoBool +
							percentagePerStep * operationalInfoBool
						}
					/>
				</div>
				{showStudentView ? (
					<Preview company={company} />
				) : (
					<>
						<CoverPhoto setCompletionBool={setCompletionBool} />
						<BasicInformation setCompletionBool={setCompletionBool} />
						<Operation setCompletionBool={setCompletionBool} />
						<VoiceOfSeniors setCompletionBool={setCompletionBool} />
					</>
				)}
			</div>
			{isProfileCompleted && showModal && (
				<ProfileCompletedModal modalCloseHandler={closeModal} />
			)}
		</Region>
	);
};

const mapStateToProps = (state) => ({
	company: state.company.company,
});

export default connect(mapStateToProps, {})(withRouter(CompanyProfile));
